"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Account = _interopRequireDefault(require("./Account"));
var _Service = _interopRequireDefault(require("./Service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ServiceLevelOrderAddItem model module.
 * @module model/ServiceLevelOrderAddItem
 * @version 3.0
 */
var ServiceLevelOrderAddItem = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ServiceLevelOrderAddItem</code>.
   * @alias module:model/ServiceLevelOrderAddItem
   */
  function ServiceLevelOrderAddItem() {
    _classCallCheck(this, ServiceLevelOrderAddItem);
    ServiceLevelOrderAddItem.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ServiceLevelOrderAddItem, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>ServiceLevelOrderAddItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ServiceLevelOrderAddItem} obj Optional instance to populate.
     * @return {module:model/ServiceLevelOrderAddItem} The populated <code>ServiceLevelOrderAddItem</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ServiceLevelOrderAddItem();
        if (data.hasOwnProperty('orderId')) {
          obj['orderId'] = _ApiClient["default"].convertToType(data['orderId'], 'Number');
        }
        if (data.hasOwnProperty('orderRefId')) {
          obj['orderRefId'] = _ApiClient["default"].convertToType(data['orderRefId'], 'String');
        }
        if (data.hasOwnProperty('orderLegacyId')) {
          obj['orderLegacyId'] = _ApiClient["default"].convertToType(data['orderLegacyId'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('statusCode')) {
          obj['statusCode'] = _ApiClient["default"].convertToType(data['statusCode'], 'String');
        }
        if (data.hasOwnProperty('creationDate')) {
          obj['creationDate'] = _ApiClient["default"].convertToType(data['creationDate'], 'Date');
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient["default"].convertToType(data['userId'], 'Number');
        }
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('extendedData')) {
          obj['extendedData'] = _ApiClient["default"].convertToType(data['extendedData'], 'String');
        }
        if (data.hasOwnProperty('extendedDataXml')) {
          obj['extendedDataXml'] = _ApiClient["default"].convertToType(data['extendedDataXml'], 'String');
        }
        if (data.hasOwnProperty('subTotal')) {
          obj['subTotal'] = _ApiClient["default"].convertToType(data['subTotal'], 'Number');
        }
        if (data.hasOwnProperty('vat')) {
          obj['vat'] = _ApiClient["default"].convertToType(data['vat'], 'Number');
        }
        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('unit')) {
          obj['unit'] = _ApiClient["default"].convertToType(data['unit'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('messageCode')) {
          obj['messageCode'] = _ApiClient["default"].convertToType(data['messageCode'], 'String');
        }
        if (data.hasOwnProperty('effectiveFromDate')) {
          obj['effectiveFromDate'] = _ApiClient["default"].convertToType(data['effectiveFromDate'], 'Date');
        }
        if (data.hasOwnProperty('account')) {
          obj['account'] = _Account["default"].constructFromObject(data['account']);
        }
        if (data.hasOwnProperty('service')) {
          obj['service'] = _Service["default"].constructFromObject(data['service']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ServiceLevelOrderAddItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ServiceLevelOrderAddItem</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['orderRefId'] && !(typeof data['orderRefId'] === 'string' || data['orderRefId'] instanceof String)) {
        throw new Error("Expected the field `orderRefId` to be a primitive type in the JSON string but got " + data['orderRefId']);
      }
      // ensure the json data is a string
      if (data['orderLegacyId'] && !(typeof data['orderLegacyId'] === 'string' || data['orderLegacyId'] instanceof String)) {
        throw new Error("Expected the field `orderLegacyId` to be a primitive type in the JSON string but got " + data['orderLegacyId']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['statusCode'] && !(typeof data['statusCode'] === 'string' || data['statusCode'] instanceof String)) {
        throw new Error("Expected the field `statusCode` to be a primitive type in the JSON string but got " + data['statusCode']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['extendedData'] && !(typeof data['extendedData'] === 'string' || data['extendedData'] instanceof String)) {
        throw new Error("Expected the field `extendedData` to be a primitive type in the JSON string but got " + data['extendedData']);
      }
      // ensure the json data is a string
      if (data['extendedDataXml'] && !(typeof data['extendedDataXml'] === 'string' || data['extendedDataXml'] instanceof String)) {
        throw new Error("Expected the field `extendedDataXml` to be a primitive type in the JSON string but got " + data['extendedDataXml']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['unit'] && !(typeof data['unit'] === 'string' || data['unit'] instanceof String)) {
        throw new Error("Expected the field `unit` to be a primitive type in the JSON string but got " + data['unit']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      // ensure the json data is a string
      if (data['messageCode'] && !(typeof data['messageCode'] === 'string' || data['messageCode'] instanceof String)) {
        throw new Error("Expected the field `messageCode` to be a primitive type in the JSON string but got " + data['messageCode']);
      }
      // validate the optional field `account`
      if (data['account']) {
        // data not null
        _Account["default"].validateJSON(data['account']);
      }
      // validate the optional field `service`
      if (data['service']) {
        // data not null
        _Service["default"].validateJSON(data['service']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} orderId
 */
ServiceLevelOrderAddItem.prototype['orderId'] = undefined;

/**
 * @member {String} orderRefId
 */
ServiceLevelOrderAddItem.prototype['orderRefId'] = undefined;

/**
 * @member {String} orderLegacyId
 */
ServiceLevelOrderAddItem.prototype['orderLegacyId'] = undefined;

/**
 * @member {String} status
 */
ServiceLevelOrderAddItem.prototype['status'] = undefined;

/**
 * @member {String} statusCode
 */
ServiceLevelOrderAddItem.prototype['statusCode'] = undefined;

/**
 * @member {Date} creationDate
 */
ServiceLevelOrderAddItem.prototype['creationDate'] = undefined;

/**
 * @member {Number} userId
 */
ServiceLevelOrderAddItem.prototype['userId'] = undefined;

/**
 * @member {Number} customerId
 */
ServiceLevelOrderAddItem.prototype['customerId'] = undefined;

/**
 * @member {String} category
 */
ServiceLevelOrderAddItem.prototype['category'] = undefined;

/**
 * @member {String} extendedData
 */
ServiceLevelOrderAddItem.prototype['extendedData'] = undefined;

/**
 * @member {String} extendedDataXml
 */
ServiceLevelOrderAddItem.prototype['extendedDataXml'] = undefined;

/**
 * @member {Number} subTotal
 */
ServiceLevelOrderAddItem.prototype['subTotal'] = undefined;

/**
 * @member {Number} vat
 */
ServiceLevelOrderAddItem.prototype['vat'] = undefined;

/**
 * @member {Number} total
 */
ServiceLevelOrderAddItem.prototype['total'] = undefined;

/**
 * @member {String} currency
 */
ServiceLevelOrderAddItem.prototype['currency'] = undefined;

/**
 * @member {String} unit
 */
ServiceLevelOrderAddItem.prototype['unit'] = undefined;

/**
 * @member {String} message
 */
ServiceLevelOrderAddItem.prototype['message'] = undefined;

/**
 * @member {String} messageCode
 */
ServiceLevelOrderAddItem.prototype['messageCode'] = undefined;

/**
 * @member {Date} effectiveFromDate
 */
ServiceLevelOrderAddItem.prototype['effectiveFromDate'] = undefined;

/**
 * @member {module:model/Account} account
 */
ServiceLevelOrderAddItem.prototype['account'] = undefined;

/**
 * @member {module:model/Service} service
 */
ServiceLevelOrderAddItem.prototype['service'] = undefined;
var _default = exports["default"] = ServiceLevelOrderAddItem;